export default __webpack_public_path__ + "static/request-demo-bg-2a1ef834e741a40cef2cf94327be8070.svg";